module.exports = __webpack_public_path__ + "static/media/SativaDomCMY.329b7a70.png";